import { DateTime } from 'luxon';

export type SelectedFilter = {
    [key: string]: unknown;
    users: MultiSelectId[];
    devices: MultiSelectId[];
    locations: MultiSelectId[];
    tenants: MultiSelectId[];
    firstAmplitude: MultiSelectId[];
    lastAmplitude: MultiSelectId[];
    firstResult: MultiSelectId[];
    lastResult: MultiSelectId[];
    ptcUse: MultiSelectId[];
    captureDateRange: { from: DateTime | null; to: DateTime | null };
    uploadDateRange: { from: DateTime | null; to: DateTime | null };
};

export type FilterData = {
    users: MultiSelectItem[];
    devices: MultiSelectItem[];
    locations: MultiSelectItem[];
    tenants: MultiSelectItem[];
    firstAmplitude: MultiSelectItem[];
    lastAmplitude: MultiSelectItem[];
    firstResult: MultiSelectItem[];
    lastResult: MultiSelectItem[];
    ptcUse: MultiSelectItem[];
    captureDateRange: { from: DateTime | null; to: DateTime | null };
    uploadDateRange: { from: DateTime | null; to: DateTime | null };
};

export type Fields =
    | 'users'
    | 'devices'
    | 'locations'
    | 'tenants'
    | 'firstAmplitude'
    | 'lastAmplitude'
    | 'firstResult'
    | 'lastResult'
    | 'ptcUse'
    | 'captureDateRange'
    | 'uploadDateRange';

export type FilterConfig = {
    fields: Fields[];
};

export const EMPTY_FILTER: SelectedFilter = {
    users: [],
    devices: [],
    locations: [],
    tenants: [],
    firstAmplitude: [],
    lastAmplitude: [],
    firstResult: [],
    lastResult: [],
    ptcUse: [],
    captureDateRange: {
        from: null,
        to: null
    },
    uploadDateRange: {
        from: null,
        to: null
    }
};
